export default class Value {
    constructor(json) {
        json = json || {};
        this.isValid = !!json.isValid;
        this.value = json.value || null;
        this.error = json.error || null;
    }

    get isEmpty() {
        if (Array.isArray(this.value)) {
            return !this.value.some(e => e)
        }
        
        if (this.value !== null && this.value.constructor.name === 'Object') {
            return !Object.entries(this.value).some(([, value]) => value !== null)
        }

        return this.value === null
    }
}